// QuestionReply — answer a question a pulsar asked (standing-agent-ui "Questions
// from the agent"). The answer is saved to the pulsar's memory; the card then
// confirms "<name> will use this from the next check-in". Used in Needs you and
// in the Action Required inbox.

import { useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Input } from '@progress/kendo-react-inputs';
import type { AttentionItem } from '@shared/api-types';
import { answerQuestion } from '../../../lib/standingAgentApi';

export function QuestionReply({ item, onChanged }: { item: AttentionItem; onChanged: () => void }) {
  const [answer, setAnswer] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (done) {
    return (
      <p className="pz-hint" role="status">
        {item.agentName} will use this from the next check-in.
      </p>
    );
  }
  const submit = async () => {
    if (!answer.trim() || !item.questionId) return;
    setBusy(true);
    setError(null);
    try {
      await answerQuestion(item.agentId, item.questionId, answer.trim());
      setDone(true);
      onChanged();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Couldn't save the answer.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <form
      className="pz-question-reply"
      onSubmit={(e) => {
        e.preventDefault();
        void submit();
      }}
    >
      <Input
        value={answer}
        onChange={(e) => setAnswer(String(e.value ?? ''))}
        aria-label={`Answer: ${item.text}`}
        placeholder="Your answer"
        maxLength={1000}
        style={{ flex: 1 }}
      />
      <Button type="submit" disabled={busy || !answer.trim()}>
        Answer
      </Button>
      {error && <span className="pz-error">{error}</span>}
    </form>
  );
}

export default QuestionReply;
